import {
  CONFIRMED_GET_ADMIN_USERS,
  CONFIRMED_ADD_ADMIN_USER,
  CONFIRMED_UPDATE_ADMIN_USER,
  CONFIRMED_DELETE_ADMIN_USER
} from "../actions/AdminUserType";

const initialState = {
  adminUsers: [],
  num_rows: 0, 
};

export default function adminUserReducer(state = initialState, action) {
  switch (action.type) {
    // case CONFIRMED_GET_ADMIN_USERS:
    //   return { ...state, adminUsers: action.payload };
    case CONFIRMED_GET_ADMIN_USERS:
      return { 
        ...state, 
        adminUsers: action.payload.adminUsers || action.payload,
        num_rows: action.payload.num_rows || 0
      };
    case CONFIRMED_ADD_ADMIN_USER:
      return {
        ...state,
        adminUsers: [...state.adminUsers, action.payload],
      };

    case CONFIRMED_UPDATE_ADMIN_USER:
      return {
        ...state,
        adminUsers: state.adminUsers.map((user) =>
          user.admin_id === action.payload.admin_id ? { ...user, ...action.payload } : user
        ),
      };

    case CONFIRMED_DELETE_ADMIN_USER:
      return {
        ...state,
        adminUsers: state.adminUsers.filter(
          (user) => user.admin_id !== action.payload.admin_id
        ),
      };

    default:
      return state;
  }
}
